/**
 * Text for a failed save. On a 409 VERSION_CONFLICT the backend's message already says who
 * changed the case (a named colleague, "You … elsewhere", or Lusca racing the save); Lusca's own
 * background writes never cause one. The page reloads the case after a conflict, so say so.
 */
export const saveErrorText = (
  err: { code?: string; message?: string },
  afterConflict = "The latest version has been loaded; please retry."
): string => {
  if (err.code !== "VERSION_CONFLICT") return err.message ?? "Save failed";
  const why =
    err.message?.trim() || "This investigation changed since you loaded it.";
  return `${why} ${afterConflict}`;
};
